<template>
  <NuxtLayout name="standard">
    <TContainer class="w-full pb-16 lg:pb-0">
      <div class="grid grid-cols-12 gap-x-4">
        <div
          class="col-span-12 row-start-2 lg:col-span-6 lg:row-start-auto flex flex-wrap content-center"
        >
          <div class="">
            <TText
              size="lg"
              tag="h2"
              variant="semibold"
              color="primary600"
              classes="mb-4"
            >
              {{ t('error.page.subtitle', { code: error?.statusCode }) }}
            </TText>
            <TTitle :tag="'h1'" size="base">{{ t('error.page.title') }}</TTitle>
            <TProse classes="prose-lg">
              <p>{{ t('error.page.text') }}</p>
              <p>
                <a href="/">{{ t('error.page.backHome') }}</a>
              </p>
            </TProse>
          </div>
        </div>
        <div class="col-span-12 row-start-1 lg:col-span-6 lg:row-start-auto">
          <img
            src="~/assets/img/pagina-error.jpg"
            class="w-full"
            alt="pagina-error"
          />
        </div>
      </div>
    </TContainer>
  </NuxtLayout>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps({
  error: Object as () => NuxtError,
})

onMounted(() => {
  if (props.error?.statusCode === 404) {
    const script = document.createElement('script')
    script.src = '//static.getclicky.com/js'
    script.async = true
    script.setAttribute('data-id', '101489167')
    document.body.appendChild(script)
  }
})
</script>
